define('home/templates/settingsBlockingButtons',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " disabled";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"fieldset\" role=\"group\">\n<button class=\"button button-outline text-medium spacing-right\" data-action=\"prev-page\""
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hasPrev : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + alias2(helpers.gettext.call(alias1,"Previous",{"name":"gettext","hash":{},"data":data}))
    + "</button>\n<button class=\"button button-outline text-medium\" data-action=\"next-page\""
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hasNext : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + alias2(helpers.gettext.call(alias1,"Next",{"name":"gettext","hash":{},"data":data}))
    + "</button>\n</div>\n";
},"useData":true})

});
